module.exports = __webpack_public_path__ + "img/odontologo.a685536b.svg";